module.exports = __webpack_public_path__ + "media/02n.fcb4c2c2.mp4";